import { useMemo } from 'react';
import { useGetAllDettesQuery } from 'actions/dettes/queries';
import { useUpdateDetteMutation } from 'actions/dettes/mutations';
import { toast } from 'react-toastify';

const useDettesData = (dossierId) => {
  const { data: dettesResponse, isLoading, isFetching, refetch } = useGetAllDettesQuery({
    dossier_id: dossierId,
  });

  const [updateDette] = useUpdateDetteMutation();

  const { updatedDettes, count, totalDettes } = useMemo(() => {
    if (!dettesResponse) {
      return { updatedDettes: [], count: 0, totalDettes: 0 };
    }

    const dettesData = Array.isArray(dettesResponse)
      ? dettesResponse
      : dettesResponse?.data;

    if (dettesData && Array.isArray(dettesData)) {
      return {
        updatedDettes: dettesData,
        count: dettesResponse?.count || dettesData.length,
        totalDettes: dettesResponse?.totalDettes || 0,
      };
    }

    return { updatedDettes: [], count: 0, totalDettes: 0 };
  }, [dettesResponse]);

  const handleUpdateDette = async (detteId, updateData) => {
    try {
      await updateDette({ id: detteId, ...updateData }).unwrap();
      refetch();
    } catch (error) {
      toast.error(
        `Erreur lors de la mise à jour: ${error.data?.error || error.message}`
      );
      console.error(error);
    }
  };

  return {
    updatedDettes,
    handleUpdateDette,
    count,
    totalDettes,
    isLoading: isLoading || (isFetching && !dettesResponse),
    refetch,
  };
};

export default useDettesData;

